import { css } from '@emotion/react';
import { useEffect, useState } from 'react';

import { getGenericBasicCards } from '@mythos/common/print/helpers';
import { isCardMercenary, isCardScavenge } from '@mythos/game/Utility';
import { useShallow } from 'zustand/shallow';
import CardView from './CardView';
import {
  MercenaryReferenceCardView,
  ProbabilityReferenceCardView,
  ScavengeReferenceCardView,
} from './ReferenceCardView';
import { useGameDefinitionsStore } from './stores/gameDefinitionsStore';

function ReferenceDebugPage() {
  const { gameDefinitions, fetchGameDefinitions } = useGameDefinitionsStore(
    useShallow((state) => ({
      gameDefinitions: state.gameDefinitions,
      fetchGameDefinitions: state.fetchGameDefinitions,
    })),
  );
  const [zoom, setZoom] = useState(2);

  useEffect(() => {
    fetchGameDefinitions();
  }, [fetchGameDefinitions]);

  if (!gameDefinitions) {
    return <div>Loading...</div>;
  }

  const { cardDefs } = gameDefinitions;

  const scavengeCards = cardDefs.filter((c) => isCardScavenge(c));
  const mercenaryCards = cardDefs.filter((c) => isCardMercenary(c));
  const genericBasics = getGenericBasicCards(cardDefs);

  return (
    <div css={ReferenceDebugStyles.pageContainer}>
      <div css={ReferenceDebugStyles.cardsContainer}>
        <div css={ReferenceDebugStyles.previewItem}>
          <div css={ReferenceDebugStyles.label}>Scavenge Reference</div>
          <div style={{ zoom }}>
            <ScavengeReferenceCardView scavengeCards={scavengeCards} />
          </div>
        </div>
        <div css={ReferenceDebugStyles.previewItem}>
          <div css={ReferenceDebugStyles.label}>Mercenary Reference</div>
          <div style={{ zoom }}>
            <MercenaryReferenceCardView mercenaryCards={mercenaryCards} />
          </div>
        </div>
        <div css={ReferenceDebugStyles.previewItem}>
          <div css={ReferenceDebugStyles.label}>Probability Reference</div>
          <div style={{ zoom }}>
            <ProbabilityReferenceCardView />
          </div>
        </div>
        <div css={ReferenceDebugStyles.previewItem}>
          <div css={ReferenceDebugStyles.label}>Generic Scavenge</div>
          <div style={{ zoom }}>
            <CardView
              card={genericBasics.scavenge}
              overrides={{ genericGainSelf: 'scavenge' }}
            />
          </div>
        </div>
        <div css={ReferenceDebugStyles.previewItem}>
          <div css={ReferenceDebugStyles.label}>Generic Mercenary</div>
          <div style={{ zoom }}>
            <CardView
              card={genericBasics.mercenary}
              overrides={{ genericCost: true, genericGainSelf: 'mercenary' }}
            />
          </div>
        </div>
        <div css={ReferenceDebugStyles.previewItem}>
          <div css={ReferenceDebugStyles.label}>Generic Settlement</div>
          <div style={{ zoom }}>
            <CardView card={genericBasics.settlement} />
          </div>
        </div>
      </div>
      <div css={ReferenceDebugStyles.controlsPanel}>
        <div css={ReferenceDebugStyles.controlsTitle}>Controls</div>
        <div css={ReferenceDebugStyles.controlGroup}>
          <label css={ReferenceDebugStyles.controlLabel}>
            Zoom: {zoom.toFixed(1)}x
          </label>
          <input
            type="range"
            min="0.5"
            max="5"
            step="0.1"
            value={zoom}
            onChange={(e) => setZoom(parseFloat(e.target.value))}
            css={ReferenceDebugStyles.slider}
          />
        </div>
      </div>
    </div>
  );
}

const ReferenceDebugStyles = {
  pageContainer: css({
    display: 'flex',
    flexDirection: 'row',
    minHeight: '100vh',
  }),
  cardsContainer: css({
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    padding: 20,
    gap: 20,
    flex: 1,
  }),
  previewItem: css({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 5,
  }),
  label: css({
    color: '#ccc',
    fontSize: 14,
  }),
  controlsPanel: css({
    width: 200,
    backgroundColor: '#1a1a1a',
    borderLeft: '1px solid #333',
    padding: 16,
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  }),
  controlsTitle: css({
    color: '#fff',
    fontSize: 16,
    fontWeight: 'bold',
    borderBottom: '1px solid #333',
    paddingBottom: 8,
  }),
  controlGroup: css({
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  }),
  controlLabel: css({
    color: '#ccc',
    fontSize: 13,
  }),
  slider: css({
    width: '100%',
    cursor: 'pointer',
  }),
};

export default ReferenceDebugPage;
